import { Button, Spinner } from '@augmentt-dev/ui-components'
import PropTypes from 'prop-types'
import React from 'react'
import { Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * Callback to hide the modal
   */
  onHide: PropTypes.func.isRequired,
  /**
   * If true, disable the buttons and show loading indicator in the primary button
   */
  loading: PropTypes.bool,
  /**
   * Close button label (formatted message id)
   */
  closeButtonLabel: PropTypes.string.isRequired,
  /**
   * Primary button label (formatted message id)
   */
  primaryButtonLabel: PropTypes.string.isRequired,
  /**
   * Callback when the primary button is clicked
   */
  onPrimaryButtonClick: PropTypes.func.isRequired,
  /**
   * If true, disables the primary button
   */
  isPrimaryButtonDisabled: PropTypes.bool,
  /**
   * If true, hides primary button
   */
  hidePrimaryButton: PropTypes.bool,
}

const defaultProps = {
  loading: false,
  isPrimaryButtonDisabled: false,
  hidePrimaryButton: false,
}

function ModalFooter(props) {
  const {
    onHide,
    closeButtonLabel,
    loading,
    primaryButtonLabel,
    onPrimaryButtonClick,
    isPrimaryButtonDisabled,
    hidePrimaryButton,
  } = props

  return (
    <Modal.Footer className="d-flex justify-content-between">
      <Button variant="secondary" onClick={onHide} disabled={loading}>
        <FormattedMessage id={closeButtonLabel} />
      </Button>
      {!hidePrimaryButton && (
        <Button variant="primary" onClick={onPrimaryButtonClick} disabled={loading || isPrimaryButtonDisabled}>
          {loading && <Spinner size="extraSmall" color="light" className="mr-2" />}
          <FormattedMessage id={primaryButtonLabel} />
        </Button>
      )}
    </Modal.Footer>
  )
}

ModalFooter.propTypes = propTypes
ModalFooter.defaultProps = defaultProps

export default ModalFooter
